import DOMPurify from "dompurify";

// Allows the embeds admins intentionally paste (iframes) while stripping scripts/event handlers.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || "", {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target"],
  });
